import api, { ApiResponse } from './api';

import { BenchmarkComparison } from 'entities/Benchmark';

export interface FreeMarketSimulationResult {
  eligible: boolean;
  reason?: string;
  monthsAnalyzed: number;
  currentAnnualCost: number;
  currentEnergyCost: number;
  currentFlagCost: number;
  annualConsumptionKwh: number;
  energyPriceMWh: number;
  managementFeeMonthly: number;
  aclEnergyCost: number;
  tusdPDiscount: number;
  demandDiscount: number;
  aclAnnualCost: number;
  annualSavings: number;
  savingsPercentage: number;
  notes: string[];
}

export interface OpportunityItem {
  id:
    | 'demand_optimization'
    | 'modality_migration'
    | 'tariff_branca'
    | 'free_market'
    | 'energy_subscription'
    | 'group_migration'
    | 'seasonal_migration';
  title: string;
  description: string;
  eligible: boolean;
  recommended: boolean;
  reason?: string;
  monthlySavings: number;
  annualSavings: number;
  currentMonthlyCost: number;
  optimizedMonthlyCost: number;
  details: Record<string, unknown>;
}

export interface OpportunitiesResult {
  baseline: {
    monthsAnalyzed: number;
    avgMonthlyKwh: number;
    avgKwhFP: number;
    avgKwhInt: number;
    avgKwhP: number;
    contractedKW: number;
    contractedKW_P: number;
    avgMeasuredKW: number;
    avgMeasuredKW_P: number;
    modality: string;
    subgroup: string;
    isGroupA: boolean;
    taxFactor: number;
  };
  opportunities: OpportunityItem[];
}

interface Response<T> {
  success: boolean;
  data: T;
}

export const getOpportunitiesService = (
  consumerUnitId: string,
  subscriptionDiscountPct?: number
): ApiResponse<Response<OpportunitiesResult>> =>
  api({
    method: 'get',
    url: `analysis/consumer-units/${consumerUnitId}/opportunities`,
    params:
      subscriptionDiscountPct != null ? { subscriptionDiscountPct } : undefined,
    useToken: true,
  });

export const getFreeMarketSimulationService = (
  consumerUnitId: string,
  params?: { energyPriceMWh?: number; managementFeeMonthly?: number }
): ApiResponse<Response<FreeMarketSimulationResult>> =>
  api({
    method: 'get',
    url: `analysis/consumer-units/${consumerUnitId}/free-market`,
    params,
    useToken: true,
  });

// Benchmark cross-cliente (admin): compara a UC com pares do mesmo setor e
// perfil de carga. Agregados anonimizados (k-anonimato no backend).
export const getBenchmarkComparisonService = (
  consumerUnitId: string
): ApiResponse<Response<BenchmarkComparison>> =>
  api({
    method: 'get',
    url: `analysis/consumer-units/${consumerUnitId}/benchmark`,
    useToken: true,
  });
